import { render, staticRenderFns } from "./AvitoAreaForm.vue?vue&type=template&id=31d63661&"
import script from "./AvitoAreaForm.vue?vue&type=script&lang=js&"
export * from "./AvitoAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports